<template>
  <v-list two-line dense>
    <ClientPhotoPermissionListItem
      v-for="(photoPermission, index) in photoPermissions"
      :client-permission="photoPermission"
      :key="index"
    />
  </v-list>
</template>
<script>
import { mapGetters } from 'vuex';
import ClientPhotoPermissionListItem from './ClientPhotoPermissionListItem';
export default {
  name: 'ClientPhotoPermissionList',
  data() {
    return {};
  },
  components: {
    ClientPhotoPermissionListItem,
  },
  computed: {
    ...mapGetters(['photoPermissions']),
  },
  created() {
    this.$store.dispatch('GET_ALL_PHOTO_PERMISSIONS');
  },
};
</script>
